import { Injectable, inject } from '@angular/core';
import { PublicisLogoUrl } from '@constants/global';
import { StatesService } from '@core/store/states.service';

@Injectable({
  providedIn: 'root',
})
export class WebsiteTitleService {
  private statesService = inject(StatesService);

  constructor() {
    // 监听用户信息变化
    this.statesService.saasUserInfo$.subscribe((saasUserInfo) => {
      let parsed: any = {};
      const beianInfo = saasUserInfo?.beian_info;
      if (beianInfo) {
        const obj = JSON.parse(beianInfo);
        parsed = obj && typeof obj === 'object' ? obj : {};
      }
      this.configureFavicon(parsed);
      this.configureTitle(parsed);
    });
  }

  /**
   * 配置标题
   */
  configureTitle(userData: any): void {
    if (window.location?.hostname?.includes('optimize.linkworld')) {
      document.title = '红品智 - 北京联世传奇网络技术有限公司';
      return;
    }
    const companyName = userData?.companyName;
    if (companyName) {
      document.title = `红品智 - ${companyName}`;
    }
  }

  /**
   * 配置 favicon
   */
  configureFavicon(userData: any): void {
    const hostname = window.location?.hostname;
    // 前端配置阳狮的 favicon
    if (hostname.includes('publicis') || hostname.includes('publicisgrowthos')) {
      this.setFavicon(PublicisLogoUrl);
      return;
    }
    const favicon = userData?.favicon;
    if (favicon) {
      this.setFavicon(favicon);
    }
  }

  /**
   * 设置 favicon 链接
   */
  private setFavicon(href: string): void {
    let faviconLink = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement | null;
    if (faviconLink) {
      faviconLink.href = href;
    }
  }
}
